import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SommaAssicurata } from '../models/somma-assicurata';
import { ResourcefulService } from './resourcefulService';



@Injectable({
  providedIn: 'root'
})
export class SommaAssicurataService extends ResourcefulService<SommaAssicurata>{
  constructor(private httpClient: HttpClient) {
    super(httpClient, SommaAssicurata);
  }
}
